import { AnalyticsImpl } from "~/modules/analytics/AnalyticsImpl";
import { CbmImpl, AddVoiceParticipantResponse, ParticipantType } from "~/modules/cbm";
import { LoggerName, getLogger } from "~/modules/logger";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { getReservationsByTask, sendTrackingEvent, getDefaultCallerID } from "~/modules/actions/ActionUtils";
import { EVENTS } from "~/modules/analytics/Analytics";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { FlexSdkError, ErrorCode, ErrorSeverity } from "~/modules/error";
import { AccountConfigDataContainer } from "~/modules/config/AccountConfig/AccountConfigImpl/AccountConfigDataContainer/AccountConfigDataContainer";
import { Action } from "~/modules/actions/Action";




















export class StartExternalWarmVoiceTaskTransfer implements Action<Promise<AddVoiceParticipantResponse>> {
    


    #taskSid: string;

    


    #phoneNumber: string;

    


    #callerId?: string;

    constructor(taskSid: string, phoneNumber: string, callerId?: string) {
        this.#taskSid = taskSid;
        this.#phoneNumber = phoneNumber;
        this.#callerId = callerId;
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const taskRouter = context.retrieveInstanceOf(ContextInstance.TaskRouter, TaskRouterImpl);
        await taskRouter.init();
        const logger = getLogger(context)(LoggerName.Actions);
        const worker = taskRouter.worker;
        const analytics = context.retrieveInstanceOf(ContextInstance.AnalyticsImpl, AnalyticsImpl);
        const cbm = context.retrieveInstanceOf(ContextInstance.CbmImpl, CbmImpl);
        await cbm.init();
        const accountConfig = context.retrieveInstanceOf(
            ContextInstance.AccountConfigDataContainer,
            AccountConfigDataContainer
        );

        logger.debug(
            `startExternalWarmVoiceTaskTransfer invoked with #taskSid: ${this.#taskSid} and #phoneNumber: ${
                this.#phoneNumber
            }`
        );

        if (!worker) {
            const errorMsg = "startExternalWarmVoiceTaskTransfer: worker is not initialized";
            logger.error(errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        const reservations = getReservationsByTask(worker, this.#taskSid);
        const reservation = reservations.find((res) => res.status === "accepted");

        if (!reservation) {
            const errorMsg = `startExternalWarmVoiceTaskTransfer: Reservation for task ${this.#taskSid} is not found`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.StartExternalWarmVoiceTaskTransferCompleted, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid
            });
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        const callerIdParam = this.#callerId || getDefaultCallerID(accountConfig.get().outboundCallFlows);
        if (!callerIdParam) {
            const errorMsg = `startExternalWarmVoiceTaskTransfer: #callerId not found`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.StartExternalWarmVoiceTaskTransferCompleted, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid,
                reservationSid: reservation.sid
            });
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        try {
            const addVoiceParticipant = await cbm.addVoiceParticipant(reservation.task, {
                from: callerIdParam,
                to: this.#phoneNumber,
                type: ParticipantType.External
            });
            sendTrackingEvent(EVENTS.StartExternalWarmVoiceTaskTransferCompleted, analytics, worker, {
                taskSid: this.#taskSid,
                reservationSid: reservation.sid
            });
            return Promise.resolve(addVoiceParticipant);
        } catch (error) {
            const errorMsg = `startExternalWarmVoiceTaskTransfer: Could not transfer task: ${error.message}`;
            sendTrackingEvent(EVENTS.StartExternalWarmVoiceTaskTransferCompleted, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid,
                reservationSid: reservation.sid
            });
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }
    }
}
